import { DEFAULT_HTTP_TIMEOUT_IN_MS } from 'MeetingsBase/constants/Defaults';
export default function applyDefaults(method, url, data) {
  return method(url, Object.assign({
    timeout: DEFAULT_HTTP_TIMEOUT_IN_MS
  }, data));
}